/**
 * Helper to obtain an specific get parameter
 *
 * @param  {String} keyToSearch
 * @return {String|null}
 */
const getUrlParam = function (keyToSearch, defaultValue = null) {
    const group = window.location.search.substr(1).split('&')
        .map(p => p.split('='))
        .find(([key]) => key === keyToSearch);
    return group ? group[1] : defaultValue;
};

/**
   * Helper to add an specific get parameter
   *
   * @param  {String} key
   * @param  {String} value
   */
const pushUrlParam = function (key, value) {
    const url = new URL(window.location.href);

    if (value) {
        url.searchParams.append(key, value);
    } else {
        url.searchParams.delete(key);
    }

    window.history.pushState(null, null, url.href);
};

/**
   * Return the full current url path with the query parameters
   *
   * @param  {Boolean} encode
   * @return {String}
   */
const getUrlFullPath = function (encode = false) {
    const url = window.location.href.replace(/^https?:\/\//, '').replace(window.location.hostname, '');
    if (encode) {
        return encodeURIComponent(url);
    }

    return url;
};

/**
   * It builds a full URL with the current host/protocol + the path used as a param.
   * By appending the current host you can avoid, for example, that someone maliciously wants to send
   * a redirection url outside the current host.
   *
   * @param  {String} path
   * @return {String}
   */
const buildHostUrl = function (path) {
    const host = `${window.location.protocol}//${window.location.hostname}`;
    return decodeURIComponent(host + path.replace(/^https?:\/\//, ''));
};

export {
    getUrlParam, pushUrlParam, getUrlFullPath, buildHostUrl,
};
